




export default function Products({ history }, props) {
  return (

      <div className="flex flex-col items-center justify-start  space-y-[24px]  h-[700px] text-[14px]  ">
        <div className="flex flex-col text-center text-[#4d4d4d]">
          <p >Our team are on hand to answer any questions </p>
          <p >you have about us and our technologies.</p>
        </div>

        <div className="flex flex-col md:flex-row h-[400px] ">
          <div className="flex float-left">
            <img src={'/assets/img/robot/robots-02.png'} width="350" />
          </div>
         
          <div className="flex flex-col float-left text-center md:text-start h-[400px] justify-center leading-[20px] ">
            <p className="font-bold">Adress:</p>
            <p >Stormansvägen 3C </p>
            <p >Sollentuna 19265 Sweden</p>
            <p className="pt-[20px] font-bold">E-Mail:</p>
            <p >info@23rd.studio</p>
          </div>

        </div>

      </div>
  )
}

